import { useEffect } from "react";
import LiveQuran from "../components/LiveQuran";
import { useQuranClass } from "../hooks/useQuranClass";

export interface LiveQuransScreenProps {
  token: string | null;
  loaderStatus?: (status: boolean) => void;
}

/**
 * Business-logic container for the Live Quran screen. Data loading and the
 * player state machine live in `useQuranClass`; this only wires them to the UI.
 */
const LiveQuransScreen = ({ token, loaderStatus }: LiveQuransScreenProps) => {
  const {
    isLoading,
    checkClass,
    currentClass,
    previousClass,
    playPreviousVideo,
  } = useQuranClass(token);

  // Suppress the app-wide loading overlay; this screen renders its own skeleton.
  useEffect(() => {
    loaderStatus?.(true);
  }, [loaderStatus]);

  return (
    <LiveQuran
      isLoading={isLoading}
      checkClass={checkClass}
      currentClass={currentClass}
      previousClass={previousClass}
      onPreviousVideoPressed={playPreviousVideo}
    />
  );
};

export default LiveQuransScreen;
